<template>
  <b-overlay :show="loader" :opacity="0.35" rounded="sm">
    <div class="card-main-div">
      <b-card title="Card Title" no-body>
        <Header
          @onExperimentChange="onExperimentChange"
          @getSpeciesTitle="getSpeciesName"
        />
      </b-card>
      <b-card class="sec-card-main-div">
        <div>
          <div class="row text-left">
            <div class="col-md-8">
              <h2 class="text-left ml-1">Genome of {{ speciesName }}</h2>
              <div class="main-chart-search-block">
                <div class="row">
                  <div class="col-md-6 col-lg-3 p-0">
                    <div class="field-main-div">
                      <b-form-group class="input-filed">
                        <v-select
                          :filterable="false"
                          :options="symbolList1"
                          label="symbol"
                          auto
                          item-value="symbol"
                          hide-details
                          id="input1"
                          v-model="input1"
                        >
                          <template #search="{ attributes, events }">
                            <input
                              type="search"
                              class="vs__search"
                              v-bind="attributes"
                              v-on="events"
                              @keyup="getSymbols(attributes.value, 'input1')"
                            /> </template
                        ></v-select>
                      </b-form-group>
                      <span class="addition-icon">+</span>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-3 p-0">
                    <div class="field-main-div">
                      <b-form-group class="input-filed">
                        <v-select
                          :filterable="false"
                          :options="symbolList2"
                          label="symbol"
                          auto
                          item-value="symbol"
                          hide-details
                          v-model="input2"
                          id="input2"
                          ><template #search="{ attributes, events }">
                            <input
                              type="search"
                              class="vs__search"
                              v-bind="attributes"
                              v-on="events"
                              @keyup="getSymbols(attributes.value, 'input2')"
                            />
                          </template>
                        </v-select>
                      </b-form-group>
                    </div>
                    <span class="addition-icon">+</span>
                  </div>
                  <div class="col-md-6 col-lg-3 p-0">
                    <div class="field-main-div">
                      <b-form-group class="input-filed">
                        <v-select
                          :filterable="false"
                          :options="symbolList3"
                          label="symbol"
                          auto
                          item-value="symbol"
                          hide-details
                          v-model="input3"
                          id="input3"
                        >
                          <template #search="{ attributes, events }">
                            <input
                              type="search"
                              class="vs__search"
                              v-bind="attributes"
                              v-on="events"
                              @keyup="getSymbols(attributes.value, 'input3')"
                            />
                          </template>
                        </v-select>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-3">
                    <b-button
                      title="Search"
                      class="mr-3 goSearch-btn"
                      @click="goSearch"
                      v-bind:disabled="isLoadingData"
                      ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="20"
                        fill="currentColor"
                        class="bi bi-forward"
                        viewBox="0 0 16 16"
                        v-show="!isLoadingData"
                      >
                        <path
                          d="M9.502 5.513a.144.144 0 0 0-.202.134V6.65a.5.5 0 0 1-.5.5H2.5v2.9h6.3a.5.5 0 0 1 .5.5v1.003c0 .108.11.176.202.134l3.984-2.933a.51.51 0 0 1 .042-.028.147.147 0 0 0 0-.252.51.51 0 0 1-.042-.028L9.502 5.513zM8.3 5.647a1.144 1.144 0 0 1 1.767-.96l3.994 2.94a1.147 1.147 0 0 1 0 1.946l-3.994 2.94a1.144 1.144 0 0 1-1.767-.96v-.503H2a.5.5 0 0 1-.5-.5v-3.9a.5.5 0 0 1 .5-.5h6.3v-.503z"
                        />
                      </svg>
                      <span v-show="isLoadingData">
                        <b-spinner label="Busy" small></b-spinner>
                        Loading...
                      </span>
                    </b-button>
                    <b-button
                      title="Reset"
                      class="reset-btn"
                      variant="light"
                      @click="reset"
                      >Reset</b-button
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="main-chart-card-block" id="main-chart-block">
                    <div class="main-chart-canvas-block">
                      <div class="mainchart-class" id="graphDiv">
                        <canvas
                          @mousemove="showTooltip"
                          @mouseout="hideTooltip"
                          id="myCanvas"
                        ></canvas>
                        <svg ref="disabledSvg" class="svg-disabled">
                          <g ref="svgX" class="x"></g>
                          <g ref="svgY" class="y"></g>
                        </svg>
                        <div
                          class="tooltip"
                          v-if="isTooltip"
                          v-html="tooltipData"
                        ></div>
                        <svg ref="highlightSvg" id="highlightSvg">
                          <circle
                            r="4"
                            v-show="showPointer"
                            ref="circlePointer"
                          ></circle>
                        </svg>
                      </div>
                      <div id="loading" v-if="showLoad">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          class="loader-svg"
                        >
                          <defs>
                            <filter id="goo">
                              <feGaussianBlur
                                in="SourceGraphic"
                                stdDeviation="10"
                                result="blur"
                              />
                              <feColorMatrix
                                in="blur"
                                mode="matrix"
                                values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 35 -10"
                                result="goo"
                              />
                              <feBlend
                                in="SourceGraphic"
                                in2="goo"
                                operator="atop"
                              />
                            </filter>
                          </defs>
                        </svg>
                        <div class="loader-svg-main">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-10">
                  <div class="slider_bar" id="point_slider">
                    <label for="slider">Fraction Of Cells Displayed</label>
                    <b-form-input
                      id="slider"
                      type="range"
                      min="10"
                      max="100"
                      step="1"
                      v-model="slider_amt"
                      @change="sliderChange"
                      class="b-form-input"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="main-chart-legend-block" id="main_legend">
                <h5 id="legend_heading">{{ legendHeading }}</h5>
                <div class="input-field mb-4" v-if="showLegendSearch">
                  <label for="search_legend_search">Search Legend</label>
                  <b-form-input
                    id="search_legend_search"
                    type="text"
                    v-model="search_legend"
                  />
                </div>
                <div id="legendCard">
                  <div>
                    <span id="close" @click="reset" role="button" tabindex="0">
                      x
                    </span>
                  </div>
                  <div v-if="showLegendSearch">
                    <LegendList
                      v-show="
                        search_legend == '' ||
                        key.cluster_name
                          .toUpperCase()
                          .includes(search_legend.toUpperCase())
                      "
                      v-for="(key, i) in expLegendsTemp"
                      :key="`legend${i}`"
                      :legendText="key.cluster_name"
                      :legnedBgColor="key.color"
                      :legendClutser="key.cluster"
                      :transform="`translate(0, ${i * 20})`"
                      @legendClick="legendHover"
                    />
                  </div>
                  <div v-else>
                    <LegendList
                      v-show="
                        search_legend == '' ||
                        key.cluster_name
                          .toUpperCase()
                          .includes(search_legend.toUpperCase())
                      "
                      v-for="(key, i) in expLegendsTemp"
                      :key="`legend${i}`"
                      :legendText="key.cluster_name"
                      :legnedBgColor="key.color"
                      :legendClutser="key.cluster"
                      :transform="`translate(0, ${i * 20})`"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  GET_EXPERIMENTS_LEGEND,
  //GET_ALL_CELL_EXPERIMENTS,
  GET_SYMBOLS,
  CELL_EXPERIMENT,
  CELL_EXPERIMENT_INTERSECTION,
} from "../../graphql/fetch-grphql";
//import testData from "./test.json";
import LegendList from "./LegendList.vue";
import { toastification } from "../../@core/mixins/toastification";
import useJwt from "../../auth/jwt/useJwt";
import { isUserLoggedIn } from "../../auth/utils";
import * as d3 from "d3";
import Header from "./Header.vue";
export default {
  name: "Home",
  data() {
    return {
      loader: false,
      showLoading: false,
      speciesName: "",
      expLegendList: [],
      allCellExpList: [],
      isLoggedIn: "",
      userName: "",
      experimentId: "",

      key_1: [],
      col_1: [],
      input1: "",
      input2: "",
      input3: "",
      symbolList1: [],
      symbolList2: [],
      symbolList3: [],
      cellExpData: [],
      colorforCluster: [],
      x_y: [],
      legend_name: [],
      clusterData: [],
      x_points: [],
      y_points: [],
      umi_count: [],
      radius: 1,
      slider_amt: 100,
      curate: [
        "#9817ff",
        "#18c61a",
        "#33b4ff",
        "#c9167e",
        "#297853",
        "#d7011b",
        "#7456c7",
        "#7e6276",
        "#afb113",
        "#fd879c",
        "#fb78fa",
        "#24c373",
        "#45bbc5",
        "#766b21",
        "#abad93",
        "#c19ce3",
        "#fd8f11",
        "#2f56ff",
        "#307a11",
        "#b3483c",
        "#0d7396",
        "#94b665",
        "#9d4d91",
        "#b807c8",
        "#086cbf",
        "#a2abc5",
        "#a35702",
        "#d3084b",
        "#8c6148",
        "#fa82ce",
        "#71be42",
        "#2bc0a0",
        "#b64064",
        "#d09fa2",
        "#daa229",
        "#5a6f68",
        "#c1aa5f",
        "#8943dc",
        "#b72ba6",
        "#6e629e",
        "#e094bf",
        "#dd8df2",
        "#c03d0b",
        "#7db799",
        "#617046",
        "#ff8a78",
        "#1263e2",
        "#91aaea",
        "#cea37e",
        "#9e555c",
        "#67b4db",
        "#05767b",
        "#537428",
        "#04c553",
        "#88b3b7",
        "#ff8d52",
        "#8abb0b",
        "#9b43b9",
        "#c83030",
        "#6fbc7c",
        "#596c83",
        "#926023",
        "#e9958d",
        "#a127e3",
        "#027b36",
        "#94577d",
        "#7543f8",
      ],
      color: [],
      points: [],
      search_legend: "",
      isLoadingData: false,
      x: 0,
      y: 0,
      margin: { top: 20, right: 20, bottom: 40, left: 40 },
      height: 0,
      width: 0,
      canvas: null,
      ctx: null,
      showPointer: false,
      showLegendSearch: true,
      isTooltip: false,
      tooltipData: "",
      legendNameAddGeneId: {},
      legendHeading: "Cell Type",
      expLegendsTemp: [],
      expIndex: 0,
    };
  },
  computed: {
    showLoad: {
      get() {
        return this.showLoading;
      },
      set(val) {
        return this.$emit("showLoader", val);
      },
    },
  },
  sockets: {
    GET_CELL_EXP(socketData) {
      if (socketData.exp_id == this.experimentId)
        this.allCellExpList = [...this.allCellExpList, ...socketData.data];

      if (this.showLoading && socketData.exp_id == this.experimentId)
        this.showLoading = false;
    },
    EXP_DATA_END(socketData) {
      if (
        this.loader &&
        socketData.exp_id == this.experimentId &&
        socketData.status
      )
        this.loader = false;
    },
    GET_FINAL_CELL_EXP(socketData) {
      if (socketData.exp_id == this.experimentId)
        this.allCellExpList = [...socketData.data];
      //this.allCellExpList.push(socketData);
    },
    GET_EXP_Legned(socketData) {
      if (socketData.exp_id == this.experimentId)
        this.expLegendList = [...socketData.data];
      //this.expLegendList.push(socketData);
    },
  },
  mounted() {
    this.canvas = document.getElementById("myCanvas");
    this.ctx = this.canvas.getContext("2d");
    var h = window.innerHeight;
    var w = window.innerWidth;
    var newH;
    if (h > w) {
      newH = w;
    } else {
      newH = h;
    }

    this.height = newH * 0.8 - this.margin.top - this.margin.bottom;
    this.width = this.height;

    this.$refs.highlightSvg.setAttribute("height", this.height);
    this.$refs.highlightSvg.setAttribute("width", this.width);
    this.$refs.disabledSvg.setAttribute(
      "height",
      this.height + this.margin.top + this.margin.bottom
    );
    this.$refs.disabledSvg.setAttribute(
      "width",
      this.width + this.margin.left + this.margin.right
    );

    this.$refs.svgX.setAttribute(
      "transform",
      `translate(${this.margin.left}, ${this.margin.top + this.height})`
    );
    this.$refs.svgY.setAttribute(
      "transform",
      `translate(${this.margin.left}, ${this.margin.top})`
    );
    this.canvas.height = this.height;
    this.canvas.width = this.width;
    // window.addEventListener("resize", this.resizer);
  },
  beforeMount() {
    this.getSpeciesName();
  },
  mixins: [toastification],
  created() {
    this.isLoggedIn = isUserLoggedIn();
    this.getUserName();
    //this.showLoading = true;
  },
  components: { Header, LegendList },
  methods: {
    showLoader(val) {
      this.showLoading = val;
    },
    getUserName() {
      this.userName = localStorage.getItem(useJwt.jwtConfig.storageUserName);
    },

    onExperimentChange(expData) {
      this.loader = true;
      this.experimentId = expData.experimentId;
      this.expIndex = expData.expIndex;
      this.showLoading = true;
      this.$socket.emit("POST_CELL_EXP", {
        experiment_id: expData.experimentId,
      });
      this.$socket.emit("POST_EXP_Legned", {
        experiment_id: expData.experimentId,
      });
      this.allCellExpList = [];
    },
    getExpLegned(experimentID) {
      this.$apollo
        .query({
          query: GET_EXPERIMENTS_LEGEND,
          variables: {
            experiment_id: experimentID,
          },
        })
        .then((res) => {
          this.expLegendList = res.data.expLegend.data;
        })
        .catch((err) => {
          this.makeToastFail(err);
        });
    },
    getSpeciesName(speciesTitle) {
      this.speciesName = speciesTitle;
    },
    async getAllCellExperiments() {
      // console.log(experimentID, GET_ALL_CELL_EXPERIMENTS);
      // this.allCellExpList = [...testData.data2];
      // let that = this;
      // setTimeout(() => {
      //   that.allCellExpList = [...that.allCellExpList, ...testData.data1];
      // }, 500);
      // setTimeout(() => {
      //   that.allCellExpList = [...that.allCellExpList, ...testData.data3];
      // }, 100);
      // setTimeout(() => {
      //   that.allCellExpList = [...that.allCellExpList, ...testData.data4];
      // }, 1500);
      //   setTimeout((that.allCellExpList = testData.data1), 1000);
      //   setTimeout((that.allCellExpList = testData.data2), 2000);
      //   setTimeout((that.allCellExpList = testData.data3), 3000);
      //   setTimeout((that.allCellExpList = testData.data4), 4000);
      // if (
      //   experimentID == "2e6e84d5-dd20-410f-b536-487b39c131c4" && !this.isLoggedIn
      // ) {
      //   this.showLoading = true;
      //   const data = await d3.csv(
      //     "https://genex-csv.s3.us-east-2.amazonaws.com/csvUploads/f6e9e690-43ad-11ec-9566-75759cc755bb.csv"
      //   );
      //   this.showLoading = false;
      //   this.allCellExpList = data;
      // } else {
      //   this.showLoading = true;
      //   this.$apollo
      //     .query({
      //       query: GET_ALL_CELL_EXPERIMENTS,
      //       variables: {
      //         experiment_id: experimentID,
      //         stage: "first",
      //       },
      //     })
      //     .then((res) => {
      //       this.allCellExpList = res.data.allCellExp.data;
      //     })
      //     .catch((err) => {
      //       this.makeToastFail(err);
      //     })
      //     .then(() => {
      //       this.showLoading = false;
      //     });
      //   this.$apollo
      //     .query({
      //       query: GET_ALL_CELL_EXPERIMENTS,
      //       variables: {
      //         experiment_id: experimentID,
      //         stage: "second",
      //       },
      //     })
      //     .then((res) => {
      //       this.allCellExpList = [
      //         ...this.allCellExpList,
      //         ...res.data.allCellExp.data,
      //       ];
      //     })
      //     .catch((err) => {
      //       this.makeToastFail(err);
      //     })
      //     .then(() => {
      //       this.showLoading = false;
      //     });
      // }
    },

    resizer() {
      this.showLoad = true;
      setTimeout(() => {
        this.showLoad = false;
        this.clearCanvas();
        this.slider_amt = 100;
        this.getAllCellExp();
      }, 1000);
    },
    showTooltip(e) {
      var factory = d3.quadtree().extent([
        [-50, -50],
        [this.width + 1, this.height + 1],
      ]);

      var tree = factory.addAll(this.points);

      var mouse = d3.pointer(e);
      if (this.x) {
        var closest = tree.find(
          this.x.invert(mouse[0]),
          this.y.invert(mouse[1]),
          this.radius
        );
        if (closest) {
          this.$refs.circlePointer.setAttribute("cx", this.x(closest[0]));
          this.$refs.circlePointer.setAttribute("cy", this.y(closest[1]));
          this.showPointer = true;

          var high_arr = [],
            umi_sum = 0,
            umi_points = [];

          for (var i = 0; i < this.points.length; i++) {
            if (this.points[i][2] === closest[2]) {
              high_arr.push(this.points[i]);
              umi_sum += this.points[i][3];
              umi_points.push(this.points[i][3]);
            }
          }

          var umi_median = this.median(umi_points);

          var names = closest[closest.length - 1].bold().toUpperCase();
          this.tooltipData =
            names +
            "<br/>" +
            "Cell Count: " +
            high_arr.length.toLocaleString() +
            "<br/>" +
            "Median UMI/cell: " +
            umi_median.toLocaleString() +
            "<br/>" +
            "Total UMI Count: " +
            umi_sum.toLocaleString();

          this.isTooltip = true;
        }
      }
    },
    hideTooltip() {
      this.tooltipData = "";
      this.showPointer = false;
      this.isTooltip = false;
    },
    getSymbols(search, inputid) {
      this.$apollo
        .query({
          query: GET_SYMBOLS,
          variables: {
            symbol_id: search,
          },
        })
        .then((res) => {
          if (inputid === "input1") {
            this.symbolList1 = res.data.getSymbols.symbolList;
          } else if (inputid === "input2") {
            this.symbolList2 = res.data.getSymbols.symbolList;
          } else if (inputid === "input3") {
            this.symbolList3 = res.data.getSymbols.symbolList;
          }
        })
        .catch((err) => {
          this.makeToastFail(err);
        });
    },
    getAllCellExp() {
      const allRows = this.allCellExpList;
      var x_arr = [],
        y_arr = [],
        cluster = [],
        cell_name = [],
        cluster_name = [];
      var cell_type = [],
        tissue = [],
        tsne = [],
        n_umi = [];

      for (var i = 0; i < allRows.length; i++) {
        let row = allRows[i];
        tsne.push(row["tsne"]);
        cell_name.push(row["cell"]);
        cell_type.push(row["cell_type"]);
        tissue.push(row["tissue"]);
        x_arr.push(row["tsne_1"]);
        y_arr.push(row["tsne_2"]);
        n_umi.push(row["n_umi"]);
        cluster.push(row["cluster"]);
        cluster_name.push(row["cluster_name"]);
      }

      this.points = [];
      var perc_slider = Math.round((allRows.length * this.slider_amt) / 100);

      for (var j = 0; j < perc_slider; j++) {
        this.points.push({
          tsne: tsne[j],
          cell: cell_name[j],
          x: Number(x_arr[j]),
          y: Number(y_arr[j]),
          n_umi: Number(n_umi[j]),
          cluster: Number(cluster[j]),
          cell_type: cell_type[j],
          cluster_name: cluster_name[j],
          tissue: tissue[j],
        });
      }
      this.cellExpData = [];
      this.cellExpData = this.points;
      this.renderChart(this.cellExpData);
    },

    async generatePointsArray(cellExpData) {
      let x_y = [],
        legend_name = [],
        clusterData = [],
        x_points = [],
        y_points = [],
        umi_count = [];

      for (var i = 0; i < cellExpData.length; i++) {
        let count = cellExpData[i].n_umi
          ? cellExpData[i].n_umi
          : cellExpData[i].count;
        x_points.push(cellExpData[i].x);
        y_points.push(cellExpData[i].y);
        clusterData.push(cellExpData[i].cluster);
        umi_count.push(count);
        legend_name.push(cellExpData[i].cluster_name);
      }

      for (var z = 0; z < x_points.length; z++) {
        x_y.push([
          x_points[z],
          y_points[z],
          clusterData[z],
          umi_count[z],
          legend_name[z],
        ]);
      }
      return x_y;
    },
    async renderChart(cellExpData, fillStyle) {
      this.color = this.curate;
      this.points = [];
      this.points = await this.generatePointsArray(cellExpData);

      var xRange = d3.extent(cellExpData, function (d) {
        return d.x;
      });
      var yRange = d3.extent(cellExpData, function (d) {
        return d.y;
      });

      const graphDiv = d3.selectAll("#graphDiv").data([0]);

      const canvas = graphDiv.selectAll("canvas").data([0]);

      const circle = canvas.selectAll("circle").data([0]);
      circle.style("fill", function (d) {
        return this.color(d.cluster);
      });

      const xAxisG = d3.selectAll("g.x").data([0]);

      const yAxisG = d3.selectAll("g.y").data([0]);

      this.x = d3.scaleLinear().domain([-50, 50]).range([0, this.width]);
      this.y = d3.scaleLinear().domain([-50, 50]).range([this.height, 0]);

      this.x.domain([xRange[0] - 5, xRange[1] + 5]);
      this.y.domain([yRange[0] - 10, yRange[1] + 10]);
      var xAxis = d3.axisBottom(this.x).ticks(d3.range(-50, 50, 25));
      var yAxis = d3.axisLeft(this.y).ticks(d3.range(-50, 50, 25));

      xAxisG.call(xAxis);
      yAxisG.call(yAxis);

      this.colorforCluster = [];
      this.paintCanvas(this.x, this.y, this.radius, fillStyle, cellExpData);
    },

    median(numbers) {
      var median = 0,
        numsLen = numbers.length;
      numbers.sort();

      if (numsLen % 2 === 0) {
        median = (numbers[numsLen / 2 - 1] + numbers[numsLen / 2]) / 2;
      } else {
        median = numbers[(numsLen - 1) / 2];
      }

      return median;
    },

    paintCanvas(x, y, radius, fillStyle, cellExpData, test) {
      if (test === "true") {
        cellExpData.forEach((d, i) => {
          setTimeout(() => {
            this.showLoad = false;
            this.paintPoint(d, i, x, y, radius, fillStyle);
          }, 500);
        });
      } else if (test !== "true") {
        cellExpData.forEach((d, i) => {
          this.paintPoint(d, i, x, y, radius, fillStyle);
        });
      }
    },
    paintPoint(d, i, x, y, radius, fillStyle) {
      this.ctx.fillStyle = fillStyle ? fillStyle : this.color[d.cluster];

      this.colorforCluster.push([Number(d.cluster), this.ctx.fillStyle]);
      this.ctx.beginPath();

      this.ctx.arc(x(d.x), y(d.y), radius, 0, 2 * Math.PI);
      this.ctx.closePath();
      this.ctx.fill();
    },
    sliderChange() {
      this.showLoad = true;
      this.input1 = "";
      this.input2 = "";
      this.input3 = "";
      this.clearLegend();
      // this.legendHeading = "Cell Type";
      // this.showLegendSearch = true;
      this.legendExp();
      // setTimeout(() => {
      //   this.showLoad = false;
      // }, 1000);
      this.clearCanvas();
      this.getAllCellExp();
      // this.slider_amt = 100;
    },
    clearCanvas() {
      this.points = [];
      var myCanvas = document.getElementById("myCanvas");
      if (myCanvas) {
        const context = myCanvas.getContext("2d");

        context.clearRect(0, 0, myCanvas.width, myCanvas.height);

        var myAxis = document.getElementById("svgAxis");
        if (myAxis) {
          myAxis.remove();
        }
      }
    },
    clearLegend() {
      this.expLegendsTemp = [];
    },
    legendExp() {
      var data_1_glob = this.expLegendList.map((legend) => {
        return {
          cluster_name: legend.cluster_name,
          cluster: Number(legend.cluster),
          n_cells: Number(legend.n_cells),
        };
      });

      let unique_cluster_global = this.uniqBy(
        this.colorforCluster,
        JSON.stringify
      );

      this.expLegendsTemp = [];
      const expLegendsTempData = [];

      for (let i = 0; i < data_1_glob.length; i++) {
        let row = data_1_glob[i];
        for (let j = 0; j < unique_cluster_global.length; j++) {
          let arr = unique_cluster_global[j];
          if (row.cluster === arr[0]) {
            expLegendsTempData.push({
              cluster: row.cluster,
              cluster_name: row.cluster_name,
              color: arr[1],
            });
          }
        }
      }
      this.expLegendsTemp = expLegendsTempData.sort((legend1, legend2) =>
        legend1.cluster_name.localeCompare(legend2.cluster_name)
      );
    },
    uniqBy(a, key) {
      var seen = {};
      return a.filter(function (item) {
        var k = key(item);
        return k in seen ? false : (seen[k] = true);
      });
    },
    legendHover(cluster) {
      this.clearCanvas();
      let legendHover_points = [];
      for (let i = 0; i < this.cellExpData.length; i++) {
        if (this.cellExpData[i]["cluster"] === cluster.key) {
          legendHover_points.push(this.cellExpData[i]);
        }
      }
      this.renderChart(this.cellExpData, "#DDDDDD");
      let expLegendsTemp1 = legendHover_points.sort();
      setTimeout(() => {
        this.paintCanvas(this.x, this.y, this.radius, null, expLegendsTemp1);
      }, 300);
    },
    async queryJson(inputVal, fillStyle) {
      var temp = [];
      try {
        this.legendNameAddGeneId[inputVal] = fillStyle;
        var res = await this.$apollo.query({
          query: CELL_EXPERIMENT,
          variables: {
            id: inputVal,
            experiment_id: this.experimentId,
          },
        });

        temp = res && res.data && res.data.cellExp ? res.data.cellExp.data : [];

        const points = temp.map((cellExp) => {
          return {
            tsne: cellExp.tsne,
            cell: cellExp.cell,
            x: Number(cellExp.tsne_1),
            y: Number(cellExp.tsne_2),
            count: Number(cellExp.count),
            cluster: Number(cellExp.cluster),
            cell_type: cellExp.cell_type,
            cluster_name: cellExp.cluster_name,
            tissue: cellExp.tissue,
          };
        });

        if (points.length === temp.length && points.length) {
          const x_y = await this.generatePointsArray(points);
          this.points = [...this.points, ...x_y];
          this.legendQuery();
          return { fillStyle, points };
        } else {
          return false;
        }
      } catch (err) {
        // console.log(inputVal, err);
        this.makeToastFail(err);
      }
    },

    legendQuery() {
      this.clearLegend();
      this.expLegendsTemp = Object.keys(this.legendNameAddGeneId).map(function (
        key
      ) {
        return {
          cluster: 0,
          cluster_name: key,
          color: this.legendNameAddGeneId[key],
        };
      },
      this);
      this.expLegendsTemp = this.expLegendsTemp.sort((legend1, legend2) =>
        legend1.cluster_name.localeCompare(legend2.cluster_name)
      );
    },

    async queryIntersect(data) {
      let temp = [];
      try {
        var res = await this.$apollo.query({
          query: CELL_EXPERIMENT_INTERSECTION,
          variables: {
            ids: data,
            experiment_id: this.experimentId,
          },
        });
        temp =
          res && res.data && res.data.intersectionExp
            ? res.data.intersectionExp.data
            : [];
        const intersection_data = temp.map((cellExp) => {
          return {
            cell: cellExp.cell,
            x: Number(cellExp.tsne_1),
            y: Number(cellExp.tsne_2),
            count: Number(cellExp.count),
            cluster: Number(cellExp.cluster),
            cell_type: cellExp.cell_type,
            cluster_name: cellExp.cluster_name,
            tissue: cellExp.tissue,
          };
        });

        if (intersection_data.length === temp.length) {
          this.points = [...this.points, ...intersection_data];
          var red = `${
            this.input1 && this.input1.symbol ? this.input1.symbol : ""
          }${this.input2 && this.input2.symbol ? this.input2.symbol : ""}${
            this.input3 && this.input3.symbol ? this.input3.symbol : ""
          }`;
          // var red =
          //   this.input1.symbol +
          //   "+" +
          //   this.input2.symbol +
          //   (this.input3 && this.input3.symbol ? "+" + this.input3.symbol : "");
          this.legendNameAddGeneId[red] = "#FF0000";
          this.legendQuery();
          this.isLoadingData = false;
          this.showLoad = false;
          return { fillStyle: "#FF0000", points: intersection_data };
        }
      } catch (err) {
        // console.log(err);
        this.makeToastFail(err);
        this.isLoadingData = false;
        this.showLoad = false;
      }
    },

    async goSearch() {
      if (this.input1.symbol || this.input2.symbol || this.input3.symbol) {
        this.showLoad = true;
        this.showLegendSearch = false;
        this.legendHeading = "Gene";
        this.clearCanvas();
        await this.renderChart(this.cellExpData, "#DDDDDD");
        this.clearLegend();
      }
      let symbolIds = [];
      this.isLoadingData = true;
      this.legendNameAddGeneId = {};
      this.points = [];
      let promiseArray = [];

      if (this.input1 && this.input1.symbol) {
        symbolIds.push(this.input1.symbol);
        promiseArray.push(this.queryJson(this.input1.symbol, "#0000FF"));
      }

      if (this.input2 && this.input2.symbol) {
        symbolIds.push(this.input2.symbol);
        promiseArray.push(this.queryJson(this.input2.symbol, "#008000"));
      }

      if (this.input3 && this.input3.symbol) {
        // console.log("hitted..");
        symbolIds.push(this.input3.symbol);
        promiseArray.push(this.queryJson(this.input3.symbol, "#FFFF00"));
      }
      // console.log(symbolIds);
      if (symbolIds.length > 1) {
        promiseArray.push(this.queryIntersect(symbolIds));
      }
      const result = await Promise.all(promiseArray);
      this.isLoadingData = false;
      this.showLoad = false;
      for (let res of result) {
        if (res) {
          this.paintCanvas(
            this.x,
            this.y,
            1.4,
            res.fillStyle,
            res.points,
            "true"
          );
        } else {
          return;
        }
      }
    },
    reset() {
      this.showLoad = true;
      this.legendNameAddGeneId = {};
      this.slider_amt = 100;
      this.isLoadingData = false;
      this.clearCanvas();
      this.clearLegend();
      this.input1 = "";
      this.input2 = "";
      this.input3 = "";
      this.search_legend = "";
      this.legendHeading = "Cell Type";
      this.showLegendSearch = true;
      this.getAllCellExp();
      setTimeout(() => {
        this.legendExp();
        this.showLoad = false;
      }, 2000);
    },
  },
  watch: {
    allCellExpList: {
      handler: function (val) {
        this.clearCanvas();
        if (val && val.length) {
          this.getAllCellExp();
          setTimeout(() => {
            this.legendExp();
          }, 2000);
        }
      },
    },
  },
};
</script>

<style scoped>
.sec-card-main-div {
  margin: 20px 30px;
}
.card-main-div {
  background-color: #f8f8f8;
}
.main-chart-search-block {
  display: block;
}
svg.caret {
  right: -15px !important;
}
.main-chart-canvas-block {
  display: block;
  height: 70vh;
}
.mainchart-class {
  position: relative;
}
.main-chart-search-block .input-filed {
  display: inline-block;
  margin: 0 6px;
  float: left;
}
.main-chart-legend-block #legendCard {
  height: calc(60vh + 52px);
  overflow-y: auto;
}
/* width */
#legendCard::-webkit-scrollbar {
  width: 7px;
}
svg {
  pointer-events: none;
}
/* Track */
#legendCard::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #dddddd;
  border-radius: 10px;
}

/* Handle */
#legendCard::-webkit-scrollbar-thumb {
  background: #dddddd;
  border-radius: 10px;
}

.main-chart-legend-block .input-field {
  margin-top: 0;
}
.legend-rect {
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: middle;
}
#highlightSvg {
  position: absolute;
  top: -15px;
  left: 40px;
  /* z-index: 1; */
}

#close {
  float: right;
  cursor: pointer;
  display: inline-block;
  padding: 2px 5px;
  background: #ccc;
}

#myCanvas {
  position: absolute;
  top: -15px;
  left: 40px;
  z-index: 1;
}

.mainchart-class {
  width: 100%;
}
#svgClusters {
  position: absolute;
  top: 25px;
  left: 5px;
  z-index: 1;
}

#svgLegend {
  position: absolute;
  top: 0;
  left: 0;
}

#svgLegendTissueType {
  position: absolute;
  top: 0;
  left: 0;
}

#svgLegendCellType {
  position: absolute;
  top: 0;
  left: 0;
}
.main-chart-card-block {
  position: relative;
}

.legend {
  display: inline-block;
  width: 300px;
  padding: 6px 0;
  cursor: pointer;
}
.legend-text:hover {
  font-weight: bold;
  font-size: 15px;
}

.tooltip {
  position: absolute;
  top: 50%;
  right: 0%;
  background-color: #fff;
  opacity: 1;
  transform: translate(-50%, -50%);
}
.svg-disabled {
  visibility: hidden !important;
}

#legendIdTissueType {
  width: 220px !important;
}

#legendIdCellType {
  width: 220px !important;
}

#loading {
  width: 100%;
  height: 65vh;
  top: 0;
  left: 0;
  position: absolute;
  display: block;
  opacity: 1;
  background-color: #fff;
  z-index: 999;
  text-align: center;
}

.loader-svg {
  height: 0px;
  width: 0px;
}

@keyframes loader {
  50% {
    transform: translateY(-16px);
    background-color: #cd3367;
  }
}

.loader-svg-main {
  filter: url("#goo");
  width: 160px;
  margin: 0 auto;
  padding: 30px;
  position: relative;
  top: 50%;
  transform: translateY(-10px);
}

.loader-svg-main > div {
  float: left;
  height: 20px;
  width: 20px;
  border-radius: 100%;
  background-color: #ff4081;
  animation: loader 1s infinite;
}

.loader-svg-main > div:nth-child(1) {
  animation-delay: 0.16s;
}

.loader-svg-main > div:nth-child(2) {
  animation-delay: 0.32s;
}

.loader-svg-main > div:nth-child(3) {
  animation-delay: 0.48s;
}

.loader-svg-main > div:nth-child(4) {
  animation-delay: 0.64s;
}

.loader-svg-main > div:nth-child(5) {
  animation-delay: 0.8s;
}
.legend-rect {
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: middle;
}
.legend-text {
  display: inline-block;
  margin: 0px 10px;
  vertical-align: middle;
  text-anchor: end;
}
.main-chart-legend-block .input-field {
  margin-top: 0;
}
.field-main-div {
  position: relative;
}
.field-main-div fieldset {
  width: 90%;
}
.addition-icon {
  position: absolute;
  right: 0px;
  top: 5px;
  transform: translate(-25%, -0%);
  font-size: 20px;
}
.field-main-div .vs__dropdown-toggle {
  border: 0px;
  border-bottom: 1px solid #9a9a9a;
  border-radius: 0px;
  padding-bottom: 10px;
}
.field-main-div .vs__dropdown-toggle:focus {
  border-bottom: 1px solid #26a69a;
  -webkit-box-shadow: 0 1px 0 0 #26a69a;
  box-shadow: 0 1px 0 0 #26a69a;
}
.goSearch-btn {
  background-color: #586363;
}
.reset-btn {
  background-color: #bbb !important;
  color: #ffffff;
}
.b-form-input {
  cursor: pointer;
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  #myCanvas,
  #highlightSvg {
    left: 0px;
    top: 15%;
  }
  .main-chart-canvas-block,
  div#graphDiv {
    height: inherit;
  }
  .sec-card-main-div {
    margin: 15px 10px;
  }
  .field-main-div fieldset {
    margin-bottom: 25px !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  #myCanvas,
  #highlightSvg {
    left: 0px;
    top: 10%;
    width: 100%;
  }
  .main-chart-canvas-block,
  div#graphDiv {
    height: inherit;
  }
  .sec-card-main-div {
    margin: 15px 10px;
  }
  .field-main-div fieldset {
    margin-bottom: 25px !important;
  }
}
</style>
